import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { Navbar } from "@/components/Navbar";
import { StaffGate } from "@/components/StaffGate";
import AgendaPage from "@/pages/AgendaPage";
import EventDetailPage from "@/pages/EventDetailPage";
import DashboardPage from "@/pages/DashboardPage";
import UsersPage from "@/pages/UsersPage";

const AuthShell = ({ children }) => <div className="flex min-h-[calc(100vh-4rem)] items-center justify-center px-4 py-10">{children}</div>;

function App() {
  return (
    <div className="App grain dark">
      <BrowserRouter>
        <ClerkAuthProvider>
          <Navbar />
          <Routes>
            <Route path="/" element={<AgendaPage />} />
            <Route path="/evento/:id" element={<EventDetailPage />} />
            <Route path="/painel" element={<StaffGate><DashboardPage /></StaffGate>} />
            <Route path="/painel/usuarios" element={<StaffGate adminOnly><UsersPage /></StaffGate>} />
            <Route path="/sign-in/*" element={<AuthShell><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthShell>} />
            <Route path="/sign-up/*" element={<AuthShell><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthShell>} />
          </Routes>
          <Toaster theme="dark" position="top-right" />
        </ClerkAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
